import Onboarded from '../../../components/admin/serviceProvider/Onboarded';
import Requested from '../../../components/admin/serviceProvider/Requested';
import withDashboardLayout from '../../../hoc/withDashboardLayout';
import { Tabs } from 'antd';
import { useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
import SendEmailNotification from '../../../components/admin/serviceProvider/SendEmailNotification';
import { useGlobalContext } from '../../../context/GlobalProvider';

const ServiceProviders = () => {
    // const [searchParams] = useSearchParams();

    const { serviceProviderActiveTab, setServiceProviderActiveTab } = useGlobalContext();
    const [modalData, setModalData] = useState({ visible: false, selectedStatus: null, data: null, id: null, action: null });
    const [notificationDrawerData, setNotificationDrawerData] = useState({ visible: false, data: null });

    const tabItems = [
        {
            key: 'onboarded',
            label: `Onboarded`,
            children: <Onboarded modalData={modalData} setModalData={setModalData} />,
        },
        {
            key: 'requested',
            label: `Requested`,
            children: <Requested />,
        },
    ];


    const onTabChange = (key) => {
        setServiceProviderActiveTab(key);
    };

    return (
        <div className='w-full h-full'>
            <div className='w-[95%] mx-auto'>

                {/* Service Provider Header */}
                <div className='w-full py-4'>
                    <h2 className='font-semibold title text-lg text-[#000000]'>Service Providers</h2>
                </div>

                {/* Service Provider */}
                <div className='w-full main-scroll min-h-[calc(100vh-170px)] h-[352px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white'>

                    <div className='w-full space-tab'>
                        <Tabs defaultActiveKey={serviceProviderActiveTab} items={tabItems} onChange={onTabChange} />
                    </div>

                    <SendEmailNotification notificationDrawerData={notificationDrawerData} setNotificationDrawerData={setNotificationDrawerData} />

                </div>
            </div>
        </div>
    )
}

export default withDashboardLayout(ServiceProviders);